/**
 * A follower / share count as it appears on a badge: `24600` becomes `"24.6K"`.
 *
 * Shared rather than copied. Three pages show these badges for the same stores — the store's own
 * coupon page, the deals page's featured hero, and a store's deals page — and the whole point of
 * those figures is that they agree. Three private copies of the rounding rule is three chances for
 * one of them to drift and show a brand a different number depending on the route taken to it.
 *
 * Below a thousand the exact number is shown: "8 followers" is honest, and "0.0K" is not a number
 * anyone writes. Past a hundred thousand the tenth is dropped, because "105K" is what a reader
 * expects and "105.0K" reads as a rounding artefact.
 */
export function formatCompactCount(value: number): string {
  if (!Number.isFinite(value) || value < 1000) {
    return String(Math.max(0, Math.round(value || 0)));
  }

  const thousands = value / 1000;
  return `${thousands >= 100 ? Math.round(thousands) : Math.round(thousands * 10) / 10}K`;
}
